<template>
  <div class="invoices-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Invoices') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <div class="pl-2 pr-2 pt-2  pb-0">
        <div class="row">
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Amount')" text-class="text-primary" key="items-general-info"
                           :amount="totalAmount" icon="money-bill"/>
          </div>
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Paid Amount')" text-class="text-success" key="items-general-info"
                           :amount="totalPaidAmount" icon="money-bill"/>
          </div>
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Outstanding Amount')" text-class="text-danger" key="items-general-info"
                           :amount="totalOutstandingAmount" icon="money-bill"/>
          </div>
        </div>
      </div>
      <InvoicesTable :hide-actions="hideInvoiceActions" :hide-action-buttons="hideActionButtons"
                     :exclude-search-fields="['shipping_status']" enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import InvoicesTable from "./../../invoices/InvoicesTable";
  import {createNamespacedHelpers} from "vuex";
  import InvoicesService from "@/modules/invoices/InvoicesService";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import AmountViewer from "@/core/components/common/AmountViewer";
  import {ON_INVOICES_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
  import {
    ACTION_BATCH_INVOICE_GENERATE,
    ACTION_CREATE_NEW_INVOICE,
    ACTION_MARK_INVOICE_DISPATCHED, ACTION_UNMARK_INVOICE_DISPATCHED
  } from "@/modules/constants";

  const {mapActions: invoicesMapActions} = createNamespacedHelpers('invoices');
  const {mapState: mapGlobalState} = createNamespacedHelpers('global');

  export default {
    name: "Invoices",
    components: {AmountViewer, PageHeader, InvoicesTable},
    data() {
      return {
        hideActions: [
          ACTION_BATCH_INVOICE_GENERATE,
          ACTION_MARK_INVOICE_DISPATCHED,
          ACTION_UNMARK_INVOICE_DISPATCHED,
        ],
        hideActionButtons: [],
        totalAmount: {},
        totalPaidAmount: {},
        totalOutstandingAmount: {},
      }
    },
    computed: {
      ...mapGlobalState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      hideInvoiceActions() {
        let actions = _.cloneDeep(this.hideActions)
        return this.enableContinuousAuction ? actions : [...actions, ACTION_CREATE_NEW_INVOICE];
      },
    },
    methods: {
      ...invoicesMapActions(['updateTableSource']),
      async getFilteredInvoicesTotalAmounts({params}) {
        let response = await InvoicesService.getInvoicesTotalAmounts(params);
        if (response.success) {
          this.$set(this, 'totalAmount', response.body.total_amount);
          this.$set(this, 'totalPaidAmount', response.body.total_paid_amount);
          this.$set(this, 'totalOutstandingAmount', response.body.total_outstanding_amount);
        }
      }
    },
    async beforeMount() {
      this.$evBus.$on(ON_INVOICES_TABLE_GET_TABLE_DATA, this.getFilteredInvoicesTotalAmounts);
      await this.updateTableSource({
        source: 'invoices',
      });
    },
    beforeDestroy() {
      this.$evBus.$off(ON_INVOICES_TABLE_GET_TABLE_DATA);
    }
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .invoices-list {
    @include list-view-wrapper;
  }
</style>
